<template>
  <div>
  </div>
</template>

<script>

export default {
  name: "AppBepiu",
  mounted() {
    location.href="https://puri.sega.jp/bepiu/app/";
  }
}
</script>

<style lang="scss" scoped>
</style>
